const gettoken = () => localStorage.getItem('ACCESS_TOKEN')
const islogin = () => !!localStorage.getItem('ACCESS_TOKEN')

export {
    gettoken,
    islogin
}